<div
  class="sidepanel"
  role="navigation"
  [hidden]="!sidePanelVisible"
  [cdkTrapFocus]="shouldTrapFocusToSidepanel">
  <div
    class="accessibility-text library-side-panel-loading-status"
    role="status"
    aria-live="polite"
    aria-atomic="true">
    @if (sidePanelLoading && sidePanelVisible) {
      <span translate="library-viewer_loading-descriptive"></span>
    }
  </div>
  @if (!sidePanelLoading) {
    <div
      class="side-panel-content"
      >
      <div class="side-panel-header">
        <h2
          translate="library-collections"
          class="side-panel-title">
        </h2>
        @if (collectionManagement) {
          <button
            type="button"
            (click)="openManageCollectionsPanel()"
            class="btn btn-none manage-collections-btn"
            data-cy="manage-collections-btn"
            [matTooltip]="'library-collections_manage-collections' | translate"
            [attr.aria-label]="'library-collections_manage-collections' | translate">
            <i class="ficon-gear"></i>
          </button>
        }
      </div>
      <ul class="side-panel-list">
        @for (collection of visibleCollections; track collection) {
          <li
            class="collection-list-item side-panel-list-item"
            data-cy="collection-list-item"
				[ngClass]="{
					'active': collection.id === selectedCollection.id,
					'mineCollection': collection.type === libraryTypes.MINE,
					'orgCollection': collection.type === libraryTypes.ORG,
					'historyCollection': collection.type === libraryTypes.ARCHIVE,
					'legacyCollection': collection.type === libraryTypes.LEGACY,
					'managedCollection': collection.type === libraryTypes.MANAGED,
					'directShareCollection': collection.type === libraryTypes.DIRECT_SHARE
				}"
            tabindex="0"
            (click)="selectCollection(collection)"
            (keyup.enter)="selectCollection(collection)"
            >
            {{collection.name}}
          </li>
        }
      </ul>
    </div>
  }
  @if (sidePanelLoading) {
    <div
      class="panel-loading"
      >
      <span class="ficon-spinner ficon-spin"></span>
      <span translate="library-viewer_loading"></span>
    </div>
  }
</div>
<main class="main-panel" role="main">
  <div
    class="accessibility-text library-main-panel-loading-status"
    role="status"
    aria-live="polite"
    aria-atomic="true">
    @if ((!sidePanelLoading && mainPanelLoading) || (!sidePanelVisible && mainPanelLoading)) {
      <span translate="library-viewer_loading-descriptive"></span>
    }
  </div>
  @if (showOverlay()) {
    <div
      class="panel-overlay"
      (click)="toggleSidePanel()">
    </div>
  }
  @if (selectedCollection && selectedContentType && contentTypes) {
    <div
      class="main-panel-content"
      >
    <div class="main-panel-header">
      <span class="left-header">
        <button
          type="button"
          class="btn btn-none toggle-side-panel-btn"
          (click)="toggleSidePanel()"
          [matTooltip]="'library-collections_show-navigation' | translate">
          <i class="ficon-menu"></i>
        </button>
        <h2 class="collection-title">{{selectedCollection.name + ': ' + selectedContentType.name}}</h2>
      </span>
      @if (mode !== modes.SELECT) {
        <mat-slide-toggle
          [hideIcon]="false"
          [(ngModel)]="multiSelect"
          (change)="toggleMultiSelect()"
          color="primary"
          class="multi-select-slide-toggle">
          {{ 'library-collections_multi-select' | translate }}
        </mat-slide-toggle>
      }
    </div>
    <div class="main-panel-sub-header">
      <div class="filter-and-sort-container">
        <div class="filter-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_filter-by' | translate }}</mat-label>
            <mat-select
              [(ngModel)]="selectedContentType"
              (selectionChange)="selectContentType($event.value)"
              disableOptionCentering
              data-cy="library-filter-menu"
              panelClass="offsetPanel">
              @for (type of contentTypes | sort:'sort_order'; track type) {
                <mat-option
                  class="filter-option"
                  [attr.data-cy]="'type-' + type.slug"
                  [value]="type">
                  {{ type.name }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        </div>
        <div class="sort-container">
          <mat-form-field goSelect>
            <mat-label>{{ 'common_sort-by' | translate }}</mat-label>
            <mat-select
              [(ngModel)]="sortBy"
              (ngModelChange)="updateTreeSort()"
              disableOptionCentering
              panelClass="offsetPanel">
              @for (option of sortOptions; track option) {
                <mat-option
                  class="sort-option"
                  [value]="option">
                  {{ sortOrderTranslations[option] | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
          </mat-form-field>
        </div>
      </div>
      <div class="search-bar">
        <div class="accessibility-text library-search-announcement" aria-live="polite" aria-atomic="true">
          {{searchAnnouncement}}
        </div>
        <div class="input-group" role="search">
          <span class="search-txt" translate="common_search"></span>
          <input type="text"
            class="form-control search-input"
            data-cy="collection-items-search"
            [formControl]="searchStrForm"
            (blur)="onSearchBlur()"
            [attr.aria-describedby]="searchError ? 'library-collections-search-error' : null"
            [attr.aria-invalid]="!!searchError ? 'true' : null"
            [attr.aria-label]="('library-viewer-item_search-label' | translate)">
          @if (!searchStr) {
            <span class="input-group-addon"><i class="ficon-search"></i></span>
          }
          @if (searchStr) {
            <span class="input-group-addon search-clear">
              <button (click)="clearSearch()" [attr.aria-label]="('common_cancel-search' | translate)" class="ficon-app-x btn-none"></button>
            </span>
          }
        </div>
        @if (searchError) {
          <div
            id="library-collections-search-error"
            class="search-result-info">
            <span>{{ searchError | translate }}</span>
          </div>
        }
        @if (searchStr && !mainPanelLoading) {
          <div class="search-result-info">
            @if (collectionItems.items.length > 0) {
              <span
                data-cy="library-viewer-item_search-result-info"
						[innerHtml]="'library-viewer-item_search-result-info' | translate: {
							text: searchStr,
							count: getResultsCount(),
							total: collectionItems.items.length}
						">
              </span>
            }
          </div>
        }
      </div>
    </div>
    @if (!mainPanelLoading) {
      @if (getItemCount() > 0 || getFolderCount() > 0) {
        <div #collectionItemsListRef
          class="collection-items-wrapper"
          data-cy="collection-items-wrapper"
          >
          <div class="collection-items-list">
            @if (getItemCount() > 0 || getFolderCount() > 0) {
              <ngx-library-tree-viewer
                [collectionItems]="collectionItems"
                [selectedCollection]="selectedCollection"
                [selectedContentType]="selectedContentType"
                [collections]="collections"
                [archiveCollection]="archiveCollection"
                [mode]="mode"
                [multiSelect]="multiSelect"
                [sortBy]="sortBy"
                [currentlySelected]="currentlySelected"
                [selectAllChecked]="selectAllChecked"
                [hideOnArchiveAndManaged]="hideOnArchiveAndManaged()"
                [searchStr]="searchStr"
                [orgSettings]="orgSettings"
                (selectItem)="select($event)"
                (setCurrentlySelected)="setCurrentlySelected($event)"
                (loadNewItems)="loadNewItems($event)"
                (setActivityPanelIsOpen)="setActivityPanelIsOpen($event)"
                (toggleSelectAll)="handleTreeSelectAll($event)"
                (copyCheckedItems)="copyItems()"
                (moveCheckedItems)="moveItems()"
                (removeCheckedItems)="removeItems()">
              </ngx-library-tree-viewer>
            }
          </div>
        </div>
      }
      <div class="zero-state-wrapper" aria-live="assertive" aria-hidden="false">
        @if (shouldShowZeroState()) {
          <ngx-zero-state
            class="zero-state-items"
            >
            @switch (selectedContentType.slug) {
              @case (CONTENT_TYPES.ALL) {
                <span zero-state-subtext translate="library-viewer-item_zero-state-all"></span>
              }
              @case (CONTENT_TYPES.MEDIA) {
                <span zero-state-subtext translate="library-viewer-item_zero-state-media"></span>
              }
              @case (CONTENT_TYPES.RUBRICS) {
                <span zero-state-subtext translate="library-viewer-item_zero-state-rubrics"></span>
              }
              @case (CONTENT_TYPES.MARKERS) {
                <span zero-state-subtext translate="library-viewer-item_zero-state-markers"></span>
              }
              @case (CONTENT_TYPES.DOCUMENTS) {
                <span zero-state-subtext translate="library-viewer-item_zero-state-documents"></span>
              }
              @case (CONTENT_TYPES.ACTIVITIES) {
                <span zero-state-subtext translate="library-viewer-item_zero-state-activities"></span>
              }
            }
          </ngx-zero-state>
        }
      </div>
      @if (collectionManagement) {
        <div class="main-panel-footer">
          @if (showActionContainer()) {
            <span
              class="action-container"
              >
              @if (selectedContentType.slug !== CONTENT_TYPES.ALL) {
                <button
                  type="button"
                  id="add-library-item-btn"
                  [attr.data-cy]="'add-' + selectedContentType.slug"
                  class="goreact-btn link-btn add-btn {{selectedContentType.slug}} add-{{selectedContentType.slug}}"
                  (click)="addLibraryItem(selectedContentType)"
                  [attr.aria-label]="('Add ' + selectedContentType.slug)">
                  <span>
                    @switch (selectedContentType.slug) {
                      @case (CONTENT_TYPES.MEDIA) {
                        <span translate="library-collections_add-media"></span>
                      }
                      @case (CONTENT_TYPES.RUBRICS) {
                        <span translate="library-collections_add-rubric"></span>
                      }
                      @case (CONTENT_TYPES.MARKERS) {
                        <span translate="library-collections_add-markers"></span>
                      }
                      @case (CONTENT_TYPES.DOCUMENTS) {
                        <span translate="library-collections_add-document"></span>
                      }
                      @case (CONTENT_TYPES.ACTIVITIES) {
                        <span translate="library-collections_add-activity"></span>
                      }
                    }
                  </span>
                </button>
              }
              @if (selectedContentType.slug === CONTENT_TYPES.ALL) {
                <button
                  type="button"
                  [matMenuTriggerFor]="typeMenu"
                  data-cy="add-all"
                  class="goreact-btn link-btn add-btn {{selectedContentType.slug}} add-{{selectedContentType.slug}} new-content-menu mat-menu-trigger"
                  >
                  <span translate="library-collections_add-content"></span>
                </button>
              }
              <mat-menu #typeMenu="matMenu">
                @for (type of contentTypesWithoutAll | sort:'sort_order'; track type) {
                  <button
                    mat-menu-item
                    type="button"
                    [attr.data-cy]="'add-' + type.slug"
                    (click)="addLibraryItem(type)"
                    >
                    <span>
                      @switch (type.slug) {
                        @case (CONTENT_TYPES.MEDIA) {
                          <span translate="library-collections_add-media"></span>
                        }
                        @case (CONTENT_TYPES.RUBRICS) {
                          <span translate="library-collections_add-rubric"></span>
                        }
                        @case (CONTENT_TYPES.MARKERS) {
                          <span translate="library-collections_add-markers"></span>
                        }
                        @case (CONTENT_TYPES.DOCUMENTS) {
                          <span translate="library-collections_add-document"></span>
                        }
                        @case (CONTENT_TYPES.ACTIVITIES) {
                          <span translate="library-collections_add-activity"></span>
                        }
                      }
                    </span>
                  </button>
                }
              </mat-menu>
              <button
                type="button"
                data-cy="add-folder"
                class="link-btn add-btn add-folder-btn goreact-btn"
                [attr.aria-label]="('library-collections_add-folder-aria' | translate)"
                (click)="openAddFolderModal()">
                <span translate="library-collections_add-folder"></span>
              </button>
            </span>
          }
          <button
            type="button"
            [ngClass]="{
              'tertiary-btn': mode === 'select',
              'primary-btn': mode !== 'select'
            }"
            class="close-btn goreact-btn"
            data-cy="lib-close-btn"
            (click)="cancel.emit()"
            translate="{{ mode === 'select' ? 'common_cancel'  : 'common_close' }}">
          </button>
        </div>
      }
    }
    <!-- Only show one loading indicator at a time, so wait until side panel loads to show this (or if side panel isn't visible) -->
    @if ((!sidePanelLoading && mainPanelLoading) || (!sidePanelVisible && mainPanelLoading)) {
      <div
        class="panel-loading"
        >
        <span class="ficon-spinner ficon-spin"></span>
        <span translate="library-viewer_loading"></span>
      </div>
    }
    </div>
  }
</main>
@if (activityPanelIsOpen()) {
  <div class="library-overlay"></div>
}
